import React from "react";
import { useQuery } from "@apollo/client";
import LoadingWrapper from "../../common/components/elements/LoadingWrapper";
import bsddFromShippingOut from "../graphql/queries/bsddFromShippingOut.graphql";
import BsddList from "./BsddList";
import PropTypes from "prop-types";

BsddShippingSendInformation.propTypes = {
  shippingUuid: PropTypes.string.isRequired,
};

export default function BsddShippingSendInformation({ shippingUuid }) {
  const { loading, error, data } = useQuery(bsddFromShippingOut, {
    variables: {
      uuid: shippingUuid,
    },
  });

  return (
    <LoadingWrapper loading={loading} error={Boolean(error)}>
      {() => {
        const bsdds = data.bsddFromShippingOut ?? [];

        return <BsddList bsdds={bsdds} />;
      }}
    </LoadingWrapper>
  );
}
